import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { firm } from "../../data/site";
import { SiteLink } from "../SiteLink";
import { VerdictVideo } from "./VerdictVideo";
export function CaseResult() {
  return <section id="case-result" aria-labelledby="result-title" className="on-dark bg-ink text-white" data-id="element-180" data-mp="ijvmzwbjuko2">
      <div className="page-container verdict-grid" data-id="element-181" data-mp="ncf3b11mftwk">
        <div data-id="element-182" data-mp="saqbl7c9pwco">
          <p className="eyebrow text-white" data-id="element-183" data-mp="sb9jrwc496di">Featured Case Study</p>
          <h2 id="result-title" className="mt-3 font-extrabold leading-[1.1] tracking-tight" data-id="element-184" data-mp="scuhtvxn37g4">
            Historic $27.5 million jury verdict
          </h2>
          <p className="mt-4 text-[23px] font-bold leading-snug" data-id="element-185" data-mp="11chigfijo984">Michigan’s largest jury verdict for an injured motorcyclist</p>
          <p className="mt-2 text-meta text-white/90" data-id="element-186" data-mp="169q0mg3p0d9d">Kent County, Michigan · May 3, 2024</p>
          <h3 className="mt-7 text-h3 font-bold" data-id="element-187" data-mp="334ch9ujpcj8x">Holding a distracted driver accountable</h3>
          <p className="mt-4 max-w-measure text-white/90" data-id="element-188" data-mp="382e7czfjpitw">
            A distracted car driver using a phone app crossed the centerline and struck a motorcyclist, whose injuries included a leg amputation.{" "}
            {firm.displayName} represented the rider and his wife, pursuing claims against the driver and her employer.
          </p>
          <SiteLink path="/27-million-motorcycle-injury-verdict/" className="mt-5 inline-flex min-h-[48px] items-center gap-2 text-label font-bold text-white underline underline-offset-4 hover:decoration-2" data-id="element-189" data-mp="1q98854m2rf0g">
            Read the full case study
            <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-190" data-mp="2iz8hbfnlze94" />
          </SiteLink>
        </div>
        <VerdictVideo data-id="element-191" data-mp="2dx9eq7zp0ld8" />
      </div>
    </section>;
}